import CardHeader, { CardHeaderProps } from "@mui/material/CardHeader";

export type { CardHeaderProps };

export default CardHeader;
